import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./reducers/rootReducer";
import axios from "axios";
import axiosMiddleware from "redux-axios-middleware";

const client = axios.create({
  //all axios can be used, shown in axios documentation
  baseURL: process.env.B2C_API_URL,
  responseType: "json",
});

const configureStoreFunc = (preloadedState) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        // Redux Toolkit includes thunk middleware by default
        // Production settings - optimize for performance
        serializableCheck: {
          ignoredActions: ['axios']
        },
        immutableCheck: false, // Disable for performance in production
      }).concat(
        axiosMiddleware(client)
      ),
    devTools: process.env.NODE_ENV !== "production", // DevTools only in development
  });
};

export default configureStoreFunc;
